export default "__VITE_PUBLIC_ASSET__a8c0a2f4__"